module.exports = __webpack_public_path__ + "img/article_3_3.24cbf523.png";